<template>
  <div class="wrapper">
    <side-bar v-if="isLoggedIn">
      <template slot="links">
        <sidebar-link
		  :to="{ name: 'ReportsDashboard' }"
		  :name="'Reports'"
		  :icon="'tim-icons icon-chart-pie-36'"
		/>
        <!-- <sidebar-link
          to="/dashboard"
          :name="$t('sidebar.dashboard')"
          icon="tim-icons icon-chart-pie-36"
        />
        <sidebar-link
          to="/icons"
          :name="$t('sidebar.icons')"
          icon="tim-icons icon-atom"
        />
        <sidebar-link
          to="/maps"
          :name="$t('sidebar.maps')"
          icon="tim-icons icon-pin"
        />
        <sidebar-link
          to="/notifications"
          :name="$t('sidebar.notifications')"
          icon="tim-icons icon-bell-55"
        />
        <sidebar-link
          to="/profile"
          :name="$t('sidebar.userProfile')"
          icon="tim-icons icon-single-02"
        />
        <sidebar-link
          to="/table-list"
          :name="$t('sidebar.tableList')"
          icon="tim-icons icon-puzzle-10"
        />
        <sidebar-link
          to="/typography"
          :name="$t('sidebar.typography')"
          icon="tim-icons icon-align-center"
        />
        -->
        <!-- <sidebar-link -->
          <!-- to="/payroll" -->
          <!-- :name="$t('Select PayRoll Cutoff')" -->
          <!-- icon="tim-icons icon-calendar-60" -->
        <!-- /> -->
        <sidebar-link
          to="/employee-records"
          :name="$t('Employe Record')"
          icon="tim-icons icon-calendar-60"
        />

          <sidebar-link
          to="/loans"
          :name="$t('Loans Managment')"
          icon="tim-icons icon-calendar-60"
        />
        <sidebar-link
          to="/cutoffs"
          :name="$t('Bulk Payroll')"
          icon="tim-icons icon-calendar-60"
        />
        <sidebar-link
		  :to="{ name: 'PositionList' }"
		  :name="'Positions'"
		  :icon="'tim-icons icon-badge'"
		/>
		<sidebar-link
		  :to="{ name: 'BranchList' }"
		  :name="'Departments'"
		  :icon="'tim-icons icon-bank'"
		/>

<!-- TRISTAN -  removed the following links to the sidebar -->
        <!-- <sidebar-link
          to="/"
          :name="$t('Recompute And Save')"
          icon="tim-icons icon-refresh-02"
        />
        <sidebar-link
          to="/"
          :name="$t('Automatic Computation')"
          icon="tim-icons icon-vector"
        />
        <sidebar-link
          to="/"
          :name="$t('Re-Pull Employee Rate')"
          icon="tim-icons icon-cloud-download-93"
        />
        <sidebar-link
          to="/"
          :name="$t('Re-Pull Emp Allowance')"
          icon="tim-icons icon-money-coins"
        />
        <sidebar-link
          to="/"
          :name="$t('Re-Pull Emp Loans')"
          icon="tim-icons icon-coins"
        />
        <sidebar-link
          to="/"
          :name="$t('Override HDMF EE Share')"
          icon="tim-icons icon-align-center"
        />
        <sidebar-link
          to="/"
          :name="$t('Remove Payroll')"
          icon="tim-icons icon-trash-simple"
        />
        <sidebar-link
          to="/"
          :name="$t('Mark As Last Pay')"
          icon="tim-icons icon-check-2"
        />
        <sidebar-link
          to="/"
          :name="$t('Apply Leave')"
          icon="tim-icons icon-app"
        />
        <sidebar-link
          to="/"
          :name="$t('Post Payroll Cutoff')"
          icon="tim-icons icon-send"
        /><sidebar-link
          to="/"
          :name="$t('Print Payslip')"
          icon="tim-icons icon-single-copy-04"
        />
        <sidebar-link
          to="/"
          :name="$t('Email Payslip')"
          icon="tim-icons icon-single-copy-04"
        />
        <sidebar-link
          to="/"
          :name="$t('Resend Payslip')"
          icon="tim-icons icon-email-85"
        />
        <sidebar-link
          to="/"
          :name="$t('Bank Trasmittal')"
          icon="tim-icons icon-bank"
        />
        <sidebar-link
          to="/"
          :name="$t('For Cheque Payroll')"
          icon="tim-icons icon-email-85"
        />
        <sidebar-link
          to="/"
          :name="$t('Reacords')"
          icon="tim-icons icon-notes"
        />
        <sidebar-link
          to="/"
          :name="$t('Payroll')"
          icon="tim-icons icon-money-coins"
        />
        <sidebar-link
          to="/"
          :name="$t('Reports')"
          icon="tim-icons icon-chart-bar-32"
        />
        <sidebar-link
          to="/"
          :name="$t('Timekeeping')"
          icon="tim-icons icon-watch-time"
        />
        <sidebar-link
          to="/"
          :name="$t('Leaves')"
          icon="tim-icons icon-calendar-60"
        /> -->
        <!-- <sidebar-link
          to="/dashboard?enableRTL=true"
          :name="$t('sidebar.rtlSupport')"
          icon="tim-icons icon-world"
        /> -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar v-if="isLoggedIn"></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
  },
  computed: {
    isLoggedIn() {
      return localStorage.getItem("isAuthenticated") === "true";
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>

